import { useState } from "react";
import { DoctorCard } from "./DoctorCard";
import {
  AppointmentSettings,
  DoctorDetails,
  DoctorSettingData,
  DoctorWithSettingsResponse,
  Slot,
} from "./types";

interface DoctorsListProps {
  selectedDoctor: DoctorDetails | null;
  dateFilter: string | null;
  selectedTimeSlot: Slot | null;
  setSelectedDoctor: (doctor: DoctorDetails) => void;
  setSelectedTimeSlot: (timeSlot: Slot | null) => void;
  onBookAppointment: (e: React.MouseEvent) => void;
  onCompleteAppointment: boolean | false;
  onDateChange: (date: string) => void;
  doctorsList: DoctorSettingData[]; // New Prop
  selectedAppointmentSetting: AppointmentSettings | null;
  setSelectedAppointmentSetting: React.Dispatch<
    React.SetStateAction<AppointmentSettings | null>
  >;
}

export function DoctorsList({
  selectedDoctor,
  selectedTimeSlot,
  setSelectedDoctor,
  setSelectedTimeSlot,
  onBookAppointment,
  doctorsList, // Used instead of doctorListing
  selectedAppointmentSetting,
  setSelectedAppointmentSetting,
  dateFilter,
}: DoctorsListProps) {
  const [selectedDoctorId, setSelectedDoctorId] = useState<string | null>(
    selectedDoctor?.userId || null,
  );

  // Find the selected doctor object from the list if needed
  // With the new structure, we iterate over doctorsList which is an array of objects

  const handleDoctorClick = (doctor: DoctorDetails | null, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if(doctor){
      setSelectedDoctorId((prev) => (prev === doctor?.userId ? null : doctor?.userId));
      if (selectedDoctor?.userId !== doctor?.userId) {
        setSelectedDoctor(doctor);
        setSelectedAppointmentSetting(null); // Reset appointment setting for new doctor
      }
    }
  };

  const handleTimeSlotClick = (
    e: React.MouseEvent,
    doctor: DoctorDetails | null,
    schedule: Slot,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if(doctor){
      setSelectedDoctor(doctor);
      setSelectedTimeSlot(schedule);
      setSelectedDoctorId(doctor?.userId);
    }
  };

  return (
    <div className="space-y-6 w-full">
      <div className="space-y-3 w-full">
        {doctorsList && doctorsList.length > 0 ? (
          doctorsList?.map((doctorData) => (
            <DoctorCard
              key={doctorData.doctorDetails.userId}
              doctor={doctorData} // Pass the new data structure directly. We need to update DoctorCard types as well.
              isSelected={selectedDoctor?.userId === doctorData.doctorDetails.userId}
              isExpanded={selectedDoctorId === doctorData.doctorDetails.userId}
              selectedTimeSlot={selectedTimeSlot}
              onDoctorClick={handleDoctorClick}
              onTimeSlotClick={handleTimeSlotClick}
              onBookAppointment={onBookAppointment}
              selectedAppointmentSetting={selectedAppointmentSetting}
              setSelectedAppointmentSetting={setSelectedAppointmentSetting}
              date={dateFilter} // Pass date to fetch slots
            />
          ))
        ) : (
          <p className="text-center text-gray-600 mt-6">No doctors available</p>
        )}
      </div>
    </div>
  );
}
